 
function openList(){
   let showSelect = document.getElementById("teste");
   let itens      = document.getElementById("select__itens");
   let icon       = document.getElementById("select__button-OpenClose");
   showSelect.classList.toggle('mostra__select');
   itens.classList.toggle('mostra__select');
   icon.classList.toggle('animaSVG');
}

function getEventTarget(e) {
   e = e || window.event;
   return e.target || e.srcElement; 
}
   
function attOptionSelected(){
   var ul = document.getElementById('select-droplist');
   let optionSelected = document.getElementById("option-selected");

   ul.onclick = function(event) {
      var optionValue = getEventTarget(event);
      optionSelected.innerHTML = optionValue.innerHTML;
      openList();
   };
}


